interface ITractorEngineOutputRange {
  rangeTitle: string;
  rangeStart: number;
  rangeEnd: number;
}

export const getTractorEngineOutputInPsRange = (engineOutputInPs: number): ITractorEngineOutputRange => {
  if (engineOutputInPs < 0) {
    return {
      rangeTitle: '잘못된 입력값',
      rangeStart: -1,
      rangeEnd: -1,
    };
  }

  if (engineOutputInPs >= 0 && engineOutputInPs <= 39) {
    return {
      rangeTitle: '소형-하우스',
      rangeStart: 0,
      rangeEnd: 39,
    };
  }

  if (engineOutputInPs >= 40 && engineOutputInPs <= 60) {
    return {
      rangeTitle: '중소형',
      rangeStart: 40,
      rangeEnd: 60,
    };
  }

  if (engineOutputInPs >= 61 && engineOutputInPs <= 80) {
    return {
      rangeTitle: '중형',
      rangeStart: 61,
      rangeEnd: 80,
    };
  }

  if (engineOutputInPs >= 81 && engineOutputInPs <= 120) {
    return {
      rangeTitle: '중대형 범용',
      rangeStart: 81,
      rangeEnd: 120,
    };
  }

  if (engineOutputInPs >= 121 && engineOutputInPs <= 170) {
    return {
      rangeTitle: '대형1',
      rangeStart: 121,
      rangeEnd: 170,
    };
  }

  if (engineOutputInPs >= 171 && engineOutputInPs <= 300) {
    return {
      rangeTitle: '대형2',
      rangeStart: 171,
      rangeEnd: 300,
    };
  }

  return {
    rangeTitle: '범위 초과',
    rangeStart: 301,
    rangeEnd: Infinity,
  };
};
